
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ReportHeaderProps {
  timePeriod: string;
  setTimePeriod: (value: string) => void;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({ timePeriod, setTimePeriod }) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-bold">Rapportages</h1>
        <p className="text-muted-foreground">
          Bekijk statistieken en analyses
        </p>
      </div>
      
      <Select value={timePeriod} onValueChange={setTimePeriod}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Periode" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="week">Afgelopen week</SelectItem>
          <SelectItem value="month">Afgelopen maand</SelectItem>
          <SelectItem value="quarter">Afgelopen kwartaal</SelectItem>
          <SelectItem value="year">Afgelopen jaar</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default ReportHeader;
